<template>
  <a
    target="_blank"
    rel="nofollow noopener"
    data-track-auto="off"
    class="inline-block bg-white active:bg-gray-50 h-full drop-shadow-1 rounded-8 break-words"
    :class="{ 'col-span-2': tile.optionalCtaLabel }"
    :href="addAffiliateMobileAppParams(tile.url)"
    @click="$emit('trackClick')"
  >
    <div
      class="p-4 md:p-6 md:flex md:items-center"
      :class="tile.optionalCtaLabel ? 'flex' : 'min-h-40 md:min-h-full'"
    >
      <SanityImage
        v-if="tile.icon"
        class="icon md:mr-2"
        :class="tile.optionalCtaLabel ? 'icon-xl mr-4' : 'icon-lg md:icon-xl mb-2'"
        :image-class="tile.optionalCtaLabel ? 'rounded-8' : ''"
        :image="tile.icon"
        :size="{ width: 100, height: 100 }"
        :lazy="false"
      />
      <div :class="!tile.icon ? 'flex flex-col h-full justify-center' : ''">
        <p class="text-16 font-semibold md:text-20">
          {{ tile.title }}
        </p>
        <p v-if="tile.description" class="text-12 font-normal md:text-18 mt-2 md:mt-1">
          {{ tile.description }}
        </p>
      </div>
    </div>
    <div
      v-if="tile.optionalCtaLabel"
      class="border-t border-gray-100 text-gray-500 text-12 px-4 py-2 flex items-center justify-end"
    >
      {{ tile.optionalCtaLabel }}
      <svg role="presentation" focusable="false" tabindex="-1" class="ml-1 icon icon-xs -rotate-90"
         
        alt=""
        svg-inline
       xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 19">
  <path fill="currentColor" fill-rule="evenodd"
    d="M.8 1.18a2.26 2.26 0 0 1 3.2 0L16 13.2 28.03 1.18a2.26 2.26 0 0 1 3.2 3.2L17.6 17.97c-.88.9-2.31.9-3.2 0L.8 4.39a2.26 2.26 0 0 1 0-3.2Z"
    clip-rule="evenodd" />
</svg>
    </div>
  </a>
</template>

<script lang="ts" setup>
import type { Tile } from './types'
defineProps<{
  tile: Tile
}>()
defineEmits(['trackClick'])
</script>
